import React from "react";

function AuthorLink({ id, className, name, email, subject }) {
    if (!email) {
        return (
            <span id={id} className={className}>
                {name}
            </span>
        );
    }

    const href =
        "mailto:" + email + "?subject=" + encodeURIComponent(subject ?? "");

    return (
        <a
            id={id}
            className={className}
            href={href}
            title={"Email " + email}
            onClick={(event) => event.stopPropagation()}
        >
            {name}
        </a>
    );
}

export default AuthorLink;